import { createNode } from '@glueapp/graph-types';

export const AddItemToList = createNode({
    id: 'Add Item to List',
    name: 'Add Item to List',
    description: 'Add an item to the end of the list',
    aiDescription:
        'Appends a single item to the end of a list. Connect a list to "List" and the item to "Item". Output: "Updated List" with the item appended.',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
        Item: {
            kind: 'generic',
            identifier: 'T',
        },
    },
    outPorts: {
        'Updated List': {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
    },
    execute: function (input) {
        const inputArray = input.inPorts.List;
        const inputItem = input.inPorts.Item;
        return { output: { 'Updated List': [...inputArray, inputItem] } };
    },
});
